import React, { useEffect, useState } from 'react'
import attendenceModals from '../modals/attendenceModals'
import common from '../methods/common'
import Actions from './widgets/Actions'
import AttendenceCalender from './widgets/AttendenceCalender'
import EditAttendence from './widgets/EditAttendence'
import MarkAttendence from './widgets/MarkAttendence'

const Attendence = () => {
    const [attendence, setAttendence] = useState([])
    useEffect(() => {
        getAttendenceByEmpId()
    }, [])

    const getAttendenceByEmpId = async () => {
        try{
            const response = await attendenceModals.getAttendenceByEmpId()
            setAttendence(common.modifyAttendence(response))
        } catch(err){
            console.log(err)
        }
    }
    const mark = async (status) => {
        try{
            const response = await attendenceModals.markAttendence({ status })
            console.log(response)
        }catch(err){
            console.log(err)
        }
    }

    return (
        <div className='pm10'>
            <h4>Please Mark your Attendence / Leave Today</h4>
            {/* <div className='main-container-flex'>
                <span className='bar-span'>Mark Attendence</span>
                <span className='bar-span'>Mark Your Team Attendence</span>
                <span className='bar-span'>View Attendence</span>
            </div> */}
            <div className='attendence-lower'>
                <div className='w30pr h100pr atetndence-left'>
                    <div className=''>
                        <MarkAttendence type="Present"/>
                        <MarkAttendence type="Leave"/>
                        <Actions handle={() => mark("Edit")} head="Edit Your Past Attendence" component={<EditAttendence />} />
                    </div>
                </div>
                <div className='h100pr'>
                    {/* Attendence View */}
                    <AttendenceCalender attendence={attendence} />
                    {/* <Calendar /> */}
                </div>
            </div>
            {/* {renderPopupPresent} */}
        </div>
    )
}

export default Attendence
